import { useSpinner as _useSpinner } from '../components/ui/spinner/useSpinner';

export const useSpinner = _useSpinner;